import { useEffect, useLayoutEffect, useRef, useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { rankingAction } from 'slices/rankingSlice';
import { getToken } from 'helpers';
import moment from 'moment';
import * as cts from '../../../constants/ui/svg';
import { Switch, Input, Modal } from 'antd';
import { IMAGE_BASE_URL_OF_USER } from '../../../constants';
import DraggableImage from './DraggableImage';
import ContentModalSlide from './ContentModalslide';
import ContentModalDefault from './ContentModalDefault';
import ContentModalSquare from './ContentModalSquare';
import {
  getCroppedImg,
  convertImageToBase64,
  createFileFromUrl,
} from '../../../helpers/functionHelper';
import CropImageRank from '../components/CropImageRank';
import { Area } from 'react-easy-crop';
import { errorToast, successToast } from 'helpers';

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedStaff: any;
  setSelectedStaff: React.Dispatch<React.SetStateAction<object>>;
};

export default function ModalChangeImage({
  open,
  setOpen,
  selectedStaff,
  setSelectedStaff,
}: Props) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const token = getToken() as string;

  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const imageShowRank = useAppSelector((state) => state.ranking.imageShowRank);
  const userStaff = useAppSelector((state) => state.ranking.userStaff);

  const [tab, setTab] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area>();
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [images, setImages] = useState<any[]>([]);
  // console.log('selectedStaff: ', selectedStaff);
  const imageSrc = useMemo(() => {
    if (selectedStaff?.imageUrl || !selectedStaff.avatar_ranking) return selectedStaff.imageUrl;
    return `${IMAGE_BASE_URL_OF_USER}/avatar_ranking_user_shop/${
      selectedStaff.avatar_ranking
    }?v=${Date.now()}`;
  }, [selectedStaff]);

  const onCropComplete = useCallback((croppedArea: Area, croppedPixels: Area) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const onSubmit = async () => {
    try {
      const processedImages = await Promise.all(
        images.map(async (img) => {
          if (!img.croppedAreaPixels) return img;
          const blob: any = await getCroppedImg(img.image, img.croppedAreaPixels);
          const file = new File([blob], `cropped_${img.position}.jpg`, { type: 'image/jpeg' });

          return { ...img, file };
        })
      );
      const hasMissingFile = processedImages.some((img) => !img.image);

      if (!croppedAreaPixels || hasMissingFile) {
        errorToast('保存する前に、2 つの画像トリミング形式をテストします。');
        return;
      }

      const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      if (croppedBlob) {
        const file = new File([croppedBlob], 'cropped.jpg', { type: 'image/jpeg' });
        dispatch(
          rankingAction.updateImageSettingAvatarRanking({
            token,
            data: {
              shop_id: selectShop.id,
              imageFile: file,
              id: selectedStaff?.id,
            },
          })
        );
      }

      setImages(processedImages);
      dispatch(
        rankingAction.updateImageShowRanking({
          token,
          data: {
            shop_id: selectShop.id,
            imageFile: processedImages,
            user_id: selectedStaff?.cid_user,
          },
        })
      );
      setSelectedStaff(userStaff);
      setTimeout(() => {
        successToast('イメージの更新が成功しました');
      }, 2000);
    } catch (error) {
      console.error('Lỗi khi lưu ảnh:', error);
    }
  };
  useEffect(() => {
    if (!selectedStaff) return;

    const initImages = Array.from({ length: 20 }, (_, idx) => ({
      position: idx,
      image: imageSrc,
      zoom: 1,
      crop: { x: 0, y: 0 },
      croppedAreaPixels: undefined,
    }));

    setImages(initImages);
  }, [selectedStaff]);
  // useEffect(() => {
  //   if (selectedStaff?.id) {
  //     dispatch(
  //       rankingAction.getImageShowRanking({
  //         token,
  //         params: { shop_id: selectShop?.id, user_id: selectedStaff?.cid_user },
  //       })
  //     );
  //   }
  // }, [selectedStaff?.id]);
  return (
    <Modal
      centered
      visible={open}
      onOk={() => setOpen(false)}
      onCancel={() => setOpen(false)}
      className="modal_change_review_img"
    >
      <div className="flex flex-col">
        <div className="flex justify-between items-center px-[16px] border-[#D5D7DA] border-b border-solid h-[56px]">
          <span className="text-[#1D2939] text-[20px] notosans_bold">
            {selectedStaff?.nick_name || userStaff?.nick_name || ' - '}
          </span>
          <button
            onClick={() => {
              setSelectedStaff({});
              setOpen(false);
              setPosition({ x: 0, y: 0 });
              setZoom(1);
              setTab(1);
            }}
            className="text-[#666687] text-[16px] notosans_medium"
          >
            {t('CLOSE')}
          </button>
        </div>
        <div className="justify-between items-center grid grid-cols-3 h-[50px]">
          <button
            onClick={() => setTab(1)}
            className={`${
              tab === 1
                ? 'text-[#666687] notosans_bold border-b-2 border-solid border-[#666687]'
                : 'text-[#939393] notosans_normal border-b border-solid border-[#D5D7DA]'
            } text-[16px] h-full`}
          >
            {t('SLIDER')}
          </button>
          <button
            onClick={() => setTab(2)}
            className={`${
              tab === 2
                ? 'text-[#666687] notosans_bold border-b-[2px] border-solid border-[#666687]'
                : 'text-[#939393] notosans_normal border-b border-solid border-[#D5D7DA]'
            } text-[16px] h-full`}
          >
            {t('DEFAULT')}
          </button>
          <button
            onClick={() => setTab(3)}
            className={`${
              tab === 3
                ? 'text-[#666687] notosans_bold border-b-[2px] border-solid border-[#666687]'
                : 'text-[#939393] notosans_normal border-b border-solid border-[#D5D7DA]'
            } text-[16px] h-full`}
          >
            1920*1920
          </button>
        </div>
        <div className="relative flex flex-1">
          <div
            className={`${
              tab === 1
                ? 'relative z-10 w-full'
                : 'absolute inset-0 z-0 opacity-0 pointer-events-none'
            }`}
          >
            <ContentModalDefault
              zoom={zoom}
              setZoom={setZoom}
              position={position}
              setPosition={setPosition}
              imageSrc={imageSrc}
              onCropComplete={onCropComplete}
              selectedStaff={selectedStaff}
            />
          </div>
          <div
            className={`${
              tab === 1
                ? 'absolute inset-0 z-0 opacity-0 pointer-events-none'
                : 'relative z-10 w-full'
            }`}
          >
            <ContentModalSlide
              selectedStaff={selectedStaff}
              images={images}
              setImages={setImages}
              //  tab={tab}
              tab={tab === 3 ? 3 : 2}
            />
          </div>
          {/* {tab === 2&&
            (
              <ContentModalSlide
                selectedStaff={selectedStaff}
                images={images}
                setImages={setImages}
                tab={tab}
              />
            )}
          {tab === 3 && (
            <ContentModalSquare
              selectedStaff={selectedStaff}
              images={images}
              setImages={setImages}
            />
          )} */}
        </div>
        {/* <CropImageRank /> */}
        <div className="gap-[8px] grid grid-cols-2 p-[12px] border-[#D0D5DD] border-t border-solid">
          <button
            onClick={() => {
              setSelectedStaff({});
              setOpen(false);
            }}
            className="flex justify-center items-center border border-[#D5D7DA] border-solid rounded-[6px] h-[44px] text-[#666687] text-[16px] notosans_medium"
          >
            {t('CANCEL')}
          </button>
          <button
            disabled={!selectedStaff?.isUpdateImagePosRanking}
            onClick={onSubmit}
            className={`bg-[#666687] rounded-[6px] h-[44px] flex items-center justify-center transition-opacity
              ${
                // !selectedStaff?.isUpdateImagePosRanking
                imageShowRank.length > 0 && !selectedStaff?.imageUrl
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:bg-[#5a5a75] cursor-pointer'
              }
            `}
          >
            <span className="ml-[8px] text-[16px] text-white notosans_medium">{t('KEEP')}</span>
          </button>
        </div>
      </div>
    </Modal>
  );
}
